export function isFornitoriMode(): boolean {
  return process.env.REACT_APP_FORNITORE_CLIENT === "1";
}
